import {
  cloneElement,
  FC,
  isValidElement,
  ReactElement,
  ReactNode,
} from 'react';
import cn from 'classnames';

import { Switch } from 'components/ui';

interface LineTextSwitchProps {
  active: boolean;
  text?: string;
  icon?: ReactNode;
  classNames?: { container?: string; text?: string; icon?: string };
  onSwitch: () => void;
  disabled?: boolean;
}

export const LineTextSwitch: FC<LineTextSwitchProps> = ({
  active,
  text,
  icon,
  classNames,
  onSwitch,
  disabled,
}) => {
  const iconElement = isValidElement(icon)
    ? cloneElement(icon as ReactElement, {
        ...icon.props,
        className: cn(icon.props.className, classNames?.icon),
      })
    : icon;

  return (
    <div
      className={cn('flex justify-between items-center', classNames?.container)}
    >
      <div className="flex items-center gap-2">
        {iconElement}
        <span className={cn('text-tpg_title', classNames?.text)}>{text}</span>
      </div>
      <Switch
        checked={active}
        onChange={onSwitch}
        classNames={{ span: disabled ? '!bg-tpg_light' : '' }}
      />
    </div>
  );
};
